import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getSessions } from '../services/ShootingData/service';
import { RawSession } from '../types/api/userSession';
import { toEnhancedSessions,  } from '../adapters/shootingDataAdapters';
import { EnhancedSession } from '../types/ui/userSession';

export function useSessions(
  limit?: number
): UseQueryResult<EnhancedSession[], Error> {
  return useQuery<RawSession[], Error, EnhancedSession[]>({
    queryKey:       ['enhancedSessions', limit],
    queryFn:        () => getSessions(limit),
    select:         rawArray => toEnhancedSessions(rawArray),
    staleTime:      5 * 60_000,
    placeholderData: last => last,
  });
}